<template>
  <div>
    <b-alert
      :show="
        (this.OpdFastTrackStemiData != '' &&
          this.OpdFastTrackStemiData != null) ||
          (this.OpdErProgressNoteData && this.OpdErProgressNoteData.length > 0)
      "
      variant="dark"
      class="margin-bottom font12px"
    >
      <h6>ER / OPD Progress Note {{ this.vnChang }}</h6>

      <b-row class="margin-bottom">
        <b-col lg="12" v-if="this.OpdFastTrackStemiData">
          <b-list-group>
            <b-list-group-item style="color:#111111;">
              <div
                v-html="OpdFastTrackStemiTextData"
                class="opd-er-progress-note-text"
              ></div>
              <hr class="hr-custom" />

              <div
                v-if="
                  this.OpdFastTrackStemiData.datas.indicators_data1_status ==
                    'Y'
                "
              >
                <b-col lg="12">
                  <div>
                    <strong>(1) เวลาที่มาถึง ER / OPD :</strong>
                    {{
                      thaiDatetimeFc.ThaiDateTime(
                        this.OpdFastTrackStemiData.datas.indicators_date1 +
                          " " +
                          this.OpdFastTrackStemiData.datas.indicators_time1
                      )
                    }}
                  </div>
                </b-col>
              </div>
              <div
                v-if="
                  this.OpdFastTrackStemiData.datas.indicators_data2_status ==
                    'Y'
                "
              >
                <b-col lg="12">
                  <div>
                    <strong>(2) ทำ EKG 12 lead :</strong>
                    {{
                      thaiDatetimeFc.ThaiDateTime(
                        this.OpdFastTrackStemiData.datas.indicators_date2 +
                          " " +
                          this.OpdFastTrackStemiData.datas.indicators_time2
                      )
                    }}
                  </div>
                </b-col>
              </div>
              <div
                v-if="
                  this.OpdFastTrackStemiData.datas.indicators_data3_status ==
                    'Y'
                "
              >
                <b-col lg="12">
                  <div>
                    <strong>(3) อายุรแพทย์ Dx เวลา :</strong>
                    {{
                      thaiDatetimeFc.ThaiDateTime(
                        this.OpdFastTrackStemiData.datas.indicators_date3 +
                          " " +
                          this.OpdFastTrackStemiData.datas.indicators_time3
                      )
                    }}
                  </div>
                </b-col>
              </div>
              <div
                v-if="
                  this.OpdFastTrackStemiData.datas.indicators_data4_status ==
                    'Y'
                "
              >
                <b-col lg="12">
                  <div>
                    <strong>(4) รถออกจาก รพ.สป เวลา :</strong>
                    {{
                      thaiDatetimeFc.ThaiDateTime(
                        this.OpdFastTrackStemiData.datas.indicators_date4 +
                          " " +
                          this.OpdFastTrackStemiData.datas.indicators_time4
                      )
                    }}
                  </div>
                </b-col>
              </div>
              <div
                v-if="
                  this.OpdFastTrackStemiData.datas.indicators_data5_status ==
                    'Y'
                "
              >
                <b-col lg="12">
                  <div>
                    <strong>(5) ให้ SK เวลา :</strong>
                    {{
                      thaiDatetimeFc.ThaiDateTime(
                        this.OpdFastTrackStemiData.datas.indicators_date5 +
                          " " +
                          this.OpdFastTrackStemiData.datas.indicators_time5
                      )
                    }}
                  </div>
                </b-col>
              </div>

              <div class="log-style">
                Log. {{ this.OpdFastTrackStemiData.datas.insert_fullname }} |
                {{
                  thaiDatetimeFc.ThaiDateTime(
                    this.OpdFastTrackStemiData.datas.insert_datetime
                  )
                }}
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>

      <b-row class="margin-bottom">
        <b-col lg="12">
          <b-list-group>
            <b-list-group-item
              v-for="item in this.OpdErProgressNoteData"
              v-bind:key="item.id"
              style="color:#111111;"
            >
              <div
                v-html="item.datas.opd_progress_note_text"
                class="opd-er-progress-note-text"
              ></div>

              <div class="log-style">
                Log. {{ item.datas.opd_progress_note_user }} |
                {{
                  thaiDatetimeFc.ThaiDateTime(
                    item.datas.opd_progress_note_datetime
                  )
                }}
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
    </b-alert>

    <div>
      <div>
        <b-modal
          id="bv-modal-progressnote"
          hide-footer
          size="xl"
          :no-close-on-backdrop="true"
          :close-on-esc="true"
        >
          <template slot="modal-title">
            ER / OPD Progress Note
          </template>

          <div class="d-block text-left margin-bottom" style="color:#000000;">
            <ckeditor
              :editor="editor"
              v-model="UserOPDNoteDatavalue"
              :config="editorConfig"
            ></ckeditor>
          </div>

          <div class="d-block text-center">
            <b-button
              variant="success"
              size="sm"
              class="d-print-none"
              @click="SubmitOpdErProgressNote('add')"
              >บันทึก</b-button
            >
            &nbsp;
            <b-button
              size="sm"
              class="d-print-none"
              @click="$bvModal.hide('bv-modal-progressnote')"
              >ยกเลิก</b-button
            >
            &nbsp;
            <b-button
              variant="danger"
              size="sm"
              class="float-right d-print-none"
              @click="DeleteProgressnoteMsgBox('Delete')"
              v-if="this.OpdErProgressNoteData"
              >ลบ</b-button
            >
          </div>
        </b-modal>
      </div>

      <div>
        <b-modal
          id="bv-modal-fast-track-stemi"
          hide-footer
          size="xl"
          :no-close-on-backdrop="true"
          :close-on-esc="true"
        >
          <template slot="modal-title">
            Fast Track STEMI
          </template>

          <div class="d-block margin-bottom" style="color:#000000;">
            <ckeditor
              :editor="editor2"
              v-model="OpdFastTrackStemiTextData"
              :config="editorConfig"
            ></ckeditor>
          </div>
          <div>
            <b-row v-if="EmrTemplateData">
              <b-col lg="3" class="margin-bottom">
                <b-form-select
                  v-model="EmrTemplateSelected"
                  :options="EmrTemplateData"
                  size="sm"
                ></b-form-select>
              </b-col>
              <b-col lg="3" class="margin-bottom">
                <b-button
                  variant="success"
                  size="sm"
                  @click="SubmitAddTemplate()"
                  >Add Template</b-button
                >
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6" class="margin-bottom">
                <b-row>
                  <b-col cols="5">
                    <b-form-checkbox
                      id="checkbox-indicators-data1"
                      v-model="indicators_data1_status"
                      name="checkbox-indicators-data1"
                      value="true"
                      unchecked-value="false"
                    >
                      (1) เวลาที่มาถึง ER / OPD :
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="7">
                    <date-picker
                      v-model="indicators_date1"
                      :lang="lang"
                      :first-day-of-week="1"
                      format="DD/MM/YYYY"
                      confirm
                      style="width:120px;"
                    ></date-picker>
                    <date-picker
                      v-model="indicators_time1"
                      lang="en"
                      type="time"
                      format="HH:mm"
                      placeholder="Select Time"
                      confirm
                      style="width:100px;"
                      :minute-step="1"
                    ></date-picker>
                  </b-col>
                </b-row>
              </b-col>

              <b-col lg="6" class="margin-bottom">
                <b-row>
                  <b-col cols="5">
                    <b-form-checkbox
                      id="checkbox-indicators-data2"
                      v-model="indicators_data2_status"
                      name="checkbox-indicators-data2"
                      value="true"
                      unchecked-value="false"
                    >
                      (2) ทำ EKG 12 lead :
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="7">
                    <date-picker
                      v-model="indicators_date2"
                      :lang="lang"
                      :first-day-of-week="1"
                      format="DD/MM/YYYY"
                      confirm
                      style="width:120px;"
                    ></date-picker>
                    <date-picker
                      v-model="indicators_time2"
                      lang="en"
                      type="time"
                      format="HH:mm"
                      placeholder="Select Time"
                      confirm
                      style="width:100px;"
                      :minute-step="1"
                    ></date-picker>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <b-row>
              <b-col lg="6" class="margin-bottom">
                <b-row>
                  <b-col cols="5">
                    <b-form-checkbox
                      id="checkbox-indicators-data3"
                      v-model="indicators_data3_status"
                      name="checkbox-indicators-data3"
                      value="true"
                      unchecked-value="false"
                    >
                      (3) อายุรแพทย์ Dx เวลา :
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="7">
                    <date-picker
                      v-model="indicators_date3"
                      :lang="lang"
                      :first-day-of-week="1"
                      format="DD/MM/YYYY"
                      confirm
                      style="width:120px;"
                    ></date-picker>
                    <date-picker
                      v-model="indicators_time3"
                      lang="en"
                      type="time"
                      format="HH:mm"
                      placeholder="Select Time"
                      confirm
                      style="width:100px;"
                      :minute-step="1"
                    ></date-picker>
                  </b-col>
                </b-row>
              </b-col>

              <b-col lg="6" class="margin-bottom">
                <b-row>
                  <b-col cols="5">
                    <b-form-checkbox
                      id="checkbox-indicators-data4"
                      v-model="indicators_data4_status"
                      name="checkbox-indicators-data4"
                      value="true"
                      unchecked-value="false"
                    >
                      (4) รถออกจาก รพ.สป เวลา :
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="7">
                    <date-picker
                      v-model="indicators_date4"
                      :lang="lang"
                      :first-day-of-week="1"
                      format="DD/MM/YYYY"
                      confirm
                      style="width:120px;"
                    ></date-picker>
                    <date-picker
                      v-model="indicators_time4"
                      lang="en"
                      type="time"
                      format="HH:mm"
                      placeholder="Select Time"
                      confirm
                      style="width:100px;"
                      :minute-step="1"
                    ></date-picker>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <b-row>
              <b-col lg="6" class="margin-bottom">
                <b-row>
                  <b-col cols="5">
                    <b-form-checkbox
                      id="checkbox-indicators-data5"
                      v-model="indicators_data5_status"
                      name="checkbox-indicators-data5"
                      value="true"
                      unchecked-value="false"
                    >
                      (5) ให้ SK เวลา :
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="7">
                    <date-picker
                      v-model="indicators_date5"
                      :lang="lang"
                      :first-day-of-week="1"
                      format="DD/MM/YYYY"
                      confirm
                      style="width:120px;"
                    ></date-picker>
                    <date-picker
                      v-model="indicators_time5"
                      lang="en"
                      type="time"
                      format="HH:mm"
                      placeholder="Select Time"
                      confirm
                      style="width:100px;"
                      :minute-step="1"
                    ></date-picker>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>

          <div class="d-block text-center">
            <b-button
              variant="success"
              class="d-print-none"
              size="sm"
              @click="SubmitFastTrackStemi('add')"
              >บันทึก</b-button
            >
            &nbsp;
            <b-button
              size="sm"
              class="d-print-none"
              @click="$bvModal.hide('bv-modal-fast-track-stemi')"
              >ยกเลิก</b-button
            >
            &nbsp;
            <b-button
              variant="danger"
              size="sm"
              class="float-right d-print-none"
              @click="DeleteFastTrackStemiMsgBox('Delete')"
              v-if="this.OpdFastTrackStemiData"
              >ลบ</b-button
            >
          </div>
        </b-modal>
      </div>
      <div v-show="false">
        <b-row v-if="this.$store.get('systems@LoginData')">
          <b-col lg="6" class="margin-bottom">
            <b-button
              variant="primary"
              size="sm"
              class="d-print-none"
              v-b-modal.bv-modal-progressnote
              @click="setDatetimeNow()"
              >บันทึก ER / OPD Progress Note</b-button
            >
          </b-col>
          <b-col lg="6" class="margin-bottom">
            <b-button
              variant="danger"
              size="sm"
              class="d-print-none"
              v-b-modal.bv-modal-fast-track-stemi
              >แนวทางการดูแลผู้ป่วย Fast Track STEMI</b-button
            >
          </b-col>
        </b-row>
      </div>
    </div>

    <!-- CSS animation example -->
    <notifications
      group="er-opd-pgn-foo-css"
      position="top right"
      animation-name="v-fade-left"
      :speed="500"
    >
    </notifications>

    <!-- Custom template example -->
    <notifications
      group="er-opd-pgn-custom-save"
      :speed="500"
      animation-name="v-fade-left"
      position="bottom right"
    >
      <template slot="body" slot-scope="props">
        <div class="er-opd-pgn-custom-save">
          <div
            class="notification-wrapper cursor-pointer"
            style="transition-timing-function: ease; transition-delay: 0s; transition-property: all;"
            @click="props.close"
          >
            <div class="vue-notification-template vue-notification">
              <div class="notification-title">{{ props.item.title }}</div>
              <div class="custom-template-text" v-html="props.item.text"></div>
            </div>
          </div>
        </div>
      </template>
    </notifications>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";
import PatientOpdErProgressNote from "@/models/patientEMRs/PatientOpdErProgressNote";
import PatientOpdFastTrackStemi from "@/models/patientEMRs/PatientOpdFastTrackStemi";
import PatientEmrTemplate from "@/models/patientEMRs/PatientEmrTemplate";

import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";

import EssentialsPlugin from "@ckeditor/ckeditor5-essentials/src/essentials";
import BoldPlugin from "@ckeditor/ckeditor5-basic-styles/src/bold";
import ItalicPlugin from "@ckeditor/ckeditor5-basic-styles/src/italic";
import LinkPlugin from "@ckeditor/ckeditor5-link/src/link";
import ParagraphPlugin from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import Font from "@ckeditor/ckeditor5-font/src/font";
import Highlight from "@ckeditor/ckeditor5-highlight/src/highlight";
import Alignment from "@ckeditor/ckeditor5-alignment/src/alignment";

Vue.use(feather, "v-icon");

@Component({
  data() {
    return {
      time1: "",
      value12: "",
      lang: {
        // days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        days: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
        months: [
          "ม.ค",
          "ก.พ",
          "มี.ค",
          "เม.ย",
          "พ.ค",
          "มิ.ย",
          "ก.ค",
          "ส.ค",
          "ก.ย",
          "ต.ค",
          "พ.ย",
          "ธ.ค"
        ],
        // months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        pickers: [
          "next 7 days",
          "next 30 days",
          "previous 7 days",
          "previous 30 days"
        ],
        placeholder: {
          date: "Select Date",
          dateRange: "Select Date Range"
        }
      },
      indicators_data1_status: false,
      indicators_data2_status: false,
      indicators_data3_status: false,
      indicators_data4_status: false,
      indicators_data5_status: false,
      indicators_date1: "",
      indicators_date2: "",
      indicators_date3: "",
      indicators_date4: "",
      indicators_date5: "",
      indicators_time1: "",
      indicators_time2: "",
      indicators_time3: "",
      indicators_time4: "",
      indicators_time5: "",
      EmrTemplateData: null,
      EmrTemplateSelected: null,
      status: false,
      vnStart: "",
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      OpdErProgressNoteData: null,
      OpdFastTrackStemiData: null,
      OpdFastTrackStemiTextData: null,
      apiCk: 0,
      ptHN: "",
      ptVN: "",
      conF: "",
      UserDT: null,
      OpdErProgressNoteCh: "",
      OpdFastTrackStemiCh: "",
      UserOPDNoteData: "",
      UserOPDNoteFullData: null,
      UserOPDNoteDatavalue: "",
      editor2: ClassicEditor,
      editor: ClassicEditor,
      editorData: "<p>Content of the editor.</p>",
      editorConfig: {
        plugins: [
          EssentialsPlugin,
          BoldPlugin,
          ItalicPlugin,
          LinkPlugin,
          ParagraphPlugin,
          Font,
          Highlight,
          Alignment
        ],

        minHeight: "300px",

        fontSize: {
          options: ["default", 9, 11, 13, 15, 17, 19, 21, 23, 25, 27]
        },

        toolbar: {
          items: [
            // 'fontFamily',
            "bold",
            "italic",
            "|",
            "fontSize",
            "fontColor",
            "highlight",
            "alignment",
            "|",
            "undo",
            "redo"
          ]
        }
      }
    };
  },
  props: ["MyVn", "MyHn"],
  component: {
    thaiDatetime,
    pjFunctions,
    PatientOpdErProgressNote,
    PatientOpdFastTrackStemi,
    PatientEmrTemplate
  },
  created() {
    (this.thaiDatetimeFc = thaiDatetime.methods),
      (this.pjFunctionsFc = pjFunctions.methods),
      this.vnChang;
    // this.getEmrTemplate('S001')
  },
  watch: {
    ptHN: function() {
      // this.setOpdErProgressNote(this.ptVN,this.ptHN)
    },
    ptVN: function() {
      this.setOpdErProgressNote(this.ptVN, this.ptHN);
      // this.getUserOEPNote(this.ptVN, this.ptHN);
      this.setOpdFastTrackStemi(this.ptVN, this.ptHN);
      // this.getOpdFastTrackStemi(this.ptVN, this.ptHN);
      this.getEmrTemplate("S001");
    },
    OpdErProgressNoteCh: function() {
      // this.getOpdErProgressNote(this.ptVN, this.ptHN);
      // this.getUserOEPNote(this.ptVN, this.ptHN);
    },
    OpdFastTrackStemiCh: function() {
      // this.setOpdFastTrackStemi(this.ptVN,this.ptHN)
      // this.getOpdFastTrackStemi(this.ptVN, this.ptHN);
    },
    UserDT: function() {
      this.getOpdErProgressNote(this.ptVN, this.ptHN);
      this.getUserOEPNote(this.ptVN, this.ptHN);
      this.setOpdFastTrackStemi(this.ptVN, this.ptHN);
      this.getOpdFastTrackStemi(this.ptVN, this.ptHN);
      // this.getEmrTemplate('S001')
    }
  },
  computed: {
    vnChang() {
      this.ptHN = this.MyHn;
      this.ptVN = this.MyVn;
      this.UserDT = this.$store.get("systems@LoginData");
    }
  },
  methods: {
    setDatetimeNow() {
      setTimeout(() => {
        this.getUserOEPNote(this.ptVN, this.ptHN);
      }, 1000);
    },
    SubmitAddTemplate() {
      this.conF = "";
      this.$bvModal
        .msgBoxConfirm("คุณแน่ใจที่จะ Add Template ใช่หรือไม่. !", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          this.conF = value;
          if (this.conF == true) {
            let ScrObj = PatientEmrTemplate.query()
              .where("id", this.EmrTemplateSelected)
              .get();

            if (ScrObj.length > 0) {
              this.OpdFastTrackStemiTextData =
                ScrObj[0].datas.emr_template_data;
            }
          }
        })
        .catch(err => {
          // An error occurred
        });
    },
    DeleteProgressnoteMsgBox(std) {
      this.conF = "";
      this.$bvModal
        .msgBoxConfirm("คุณแน่ใจที่จะลบข้อมูลใช่หรือไม่. !", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          this.conF = value;
          if (this.conF == true) {
            this.SubmitOpdErProgressNote(std);
          }
        })
        .catch(err => {
          // An error occurred
        });
    },

    DeleteFastTrackStemiMsgBox(std) {
      this.conF = "";
      this.$bvModal
        .msgBoxConfirm("คุณแน่ใจที่จะลบข้อมูลใช่หรือไม่. !", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          this.conF = value;
          if (this.conF == true) {
            this.SubmitFastTrackStemi(std);
          }
        })
        .catch(err => {
          // An error occurred
        });
    },
    show(group, type = "", title = "", text = "") {
      //const text = `
      //  This is notification text!
      //  <br>
      //  Date: ${new Date()}
      // `
      this.$notify({
        group,
        title: title,
        text: text,
        type,
        data: {
          randomNumber: Math.random()
        }
      });
    },
    clean(group) {
      this.$notify({ group, clean: true });
    },
    SubmitFastTrackStemi(std) {
      this.conF = "";
      this.$bvModal
        .msgBoxConfirm("ยืนยันการบันทึกข้อมูล. !", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          this.conF = value;
          if (this.conF == true) {
            if (
              this.ptVN != "" &&
              this.ptHN != "" &&
              this.OpdFastTrackStemiTextData != ""
            ) {
              let NoteText = "";
              let TXindicators_data1_status = false;
              let TXindicators_data2_status = false;
              let TXindicators_data3_status = false;
              let TXindicators_data4_status = false;
              let TXindicators_data5_status = false;

              if (std == "Delete") {
                NoteText = "-";
                TXindicators_data1_status = false;
                TXindicators_data2_status = false;
                TXindicators_data3_status = false;
                TXindicators_data4_status = false;
                TXindicators_data5_status = false;
              } else {
                NoteText = this.OpdFastTrackStemiTextData;
                TXindicators_data1_status = this.indicators_data1_status;
                TXindicators_data2_status = this.indicators_data2_status;
                TXindicators_data3_status = this.indicators_data3_status;
                TXindicators_data4_status = this.indicators_data4_status;
                TXindicators_data5_status = this.indicators_data5_status;
              }

              let formData = new FormData();
              formData.append(
                "CompanyId",
                this.$store.get("systems@CompanyId")
              );
              formData.append("ApiKey", this.$store.get("systems@ApiKey"));
              formData.append("hn", this.ptHN);
              formData.append("vn", this.ptVN);

              formData.append("opdfast_track_stemi_ext", NoteText);
              formData.append(
                "indicators_data1_status",
                TXindicators_data1_status
              );
              formData.append(
                "indicators_data2_status",
                TXindicators_data2_status
              );
              formData.append(
                "indicators_data3_status",
                TXindicators_data3_status
              );
              formData.append(
                "indicators_data4_status",
                TXindicators_data4_status
              );
              formData.append(
                "indicators_data5_status",
                TXindicators_data5_status
              );

              formData.append(
                "indicators_date1",
                this.thaiDatetimeFc.DateTimeToStrDate(this.indicators_date1)
              );
              formData.append(
                "indicators_date2",
                this.thaiDatetimeFc.DateTimeToStrDate(this.indicators_date2)
              );
              formData.append(
                "indicators_date3",
                this.thaiDatetimeFc.DateTimeToStrDate(this.indicators_date3)
              );
              formData.append(
                "indicators_date4",
                this.thaiDatetimeFc.DateTimeToStrDate(this.indicators_date4)
              );
              formData.append(
                "indicators_date5",
                this.thaiDatetimeFc.DateTimeToStrDate(this.indicators_date5)
              );

              formData.append(
                "indicators_time1",
                this.thaiDatetimeFc.DateTimeToStrTime(this.indicators_time1)
              );
              formData.append(
                "indicators_time2",
                this.thaiDatetimeFc.DateTimeToStrTime(this.indicators_time2)
              );
              formData.append(
                "indicators_time3",
                this.thaiDatetimeFc.DateTimeToStrTime(this.indicators_time3)
              );
              formData.append(
                "indicators_time4",
                this.thaiDatetimeFc.DateTimeToStrTime(this.indicators_time4)
              );
              formData.append(
                "indicators_time5",
                this.thaiDatetimeFc.DateTimeToStrTime(this.indicators_time5)
              );

              let ScrObj = this;
              this.axios
                .post(
                  this.$store.get("systems@UrlApi") + "OpdFastTrackStemiAdd",
                  formData,
                  {
                    headers: {
                      "Content-Type": "multipart/form-data"
                    }
                  }
                )
                .then(function(response) {
                  ScrObj.output = response.data;
                  if (ScrObj.output.status === true) {
                    ScrObj.setOpdFastTrackStemi(ScrObj.ptVN, ScrObj.ptHN);

                    ScrObj.show(
                      "er-opd-pgn-foo-css",
                      "success",
                      "Save Data Success",
                      "การบันทึกข้อมูลเสร็จสมบูรณ์ ^_^ <br>Date : " +
                        ScrObj.thaiDatetimeFc.ThaiDateTime(
                          ScrObj.thaiDatetimeFc.DateTimeNow()
                        )
                    );

                    ScrObj.$bvModal.hide("bv-modal-fast-track-stemi");
                  } else {
                    ScrObj.show(
                      "er-opd-pgn-foo-css",
                      "warn",
                      "Save Data Error",
                      "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                        "<br>ErrorMessage : " +
                        ScrObj.output.ErrorMessage +
                        "<br>Date : " +
                        ScrObj.thaiDatetimeFc.ThaiDateTime(
                          ScrObj.thaiDatetimeFc.DateTimeNow()
                        )
                    );

                    // console.log('DrugNonDrugNoteAdd : '+ScrObj.output.ErrorMessage)
                  }
                })
                .catch(function(error) {
                  ScrObj.output = error;

                  ScrObj.show(
                    "er-opd-pgn-foo-css",
                    "error",
                    "Save Data Error",
                    "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                      "<br>ErrorMessage : " +
                      ScrObj.output +
                      "<br>Date : " +
                      ScrObj.thaiDatetimeFc.ThaiDateTime(
                        ScrObj.thaiDatetimeFc.DateTimeNow()
                      )
                  );

                  console.log("OpdFastTrackStemiAdd : " + ScrObj.output);
                });
            }
          }
        });
    },
    SubmitOpdErProgressNote(std) {
      this.conF = "";
      this.$bvModal
        .msgBoxConfirm("ยืนยันการบันทึกข้อมูล. !", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          this.conF = value;
          if (this.conF == true) {
            if (
              this.ptVN != "" &&
              this.ptHN != "" &&
              this.UserOPDNoteDatavalue != ""
            ) {
              let NoteText = "";

              if (std == "Delete") {
                NoteText = "-";
              } else {
                NoteText = this.UserOPDNoteDatavalue;
              }

              let ScrObj = this;
              this.axios
                .post(
                  this.$store.get("systems@UrlApi") + "OpdErProgressNoteAdd",
                  {
                    CompanyId: this.$store.get("systems@CompanyId"),
                    ApiKey: this.$store.get("systems@ApiKey"),
                    hn: ScrObj.ptHN,
                    vn: ScrObj.ptVN,
                    opd_progress_note_text: NoteText
                  }
                )
                .then(function(response) {
                  ScrObj.output = response.data;
                  if (ScrObj.output.status === true) {
                    ScrObj.setOpdErProgressNote(ScrObj.ptVN, ScrObj.ptHN);

                    ScrObj.show(
                      "er-opd-pgn-foo-css",
                      "success",
                      "Save Data Success",
                      "การบันทึกข้อมูลเสร็จสมบูรณ์ ^_^ <br>Date : " +
                        ScrObj.thaiDatetimeFc.ThaiDateTime(
                          ScrObj.thaiDatetimeFc.DateTimeNow()
                        )
                    );

                    ScrObj.$bvModal.hide("bv-modal-progressnote");
                  } else {
                    ScrObj.show(
                      "er-opd-pgn-foo-css",
                      "warn",
                      "Save Data Error",
                      "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                        "<br>ErrorMessage : " +
                        ScrObj.output.ErrorMessage +
                        "<br>Date : " +
                        ScrObj.thaiDatetimeFc.ThaiDateTime(
                          ScrObj.thaiDatetimeFc.DateTimeNow()
                        )
                    );

                    // console.log('DrugNonDrugNoteAdd : '+ScrObj.output.ErrorMessage)
                  }
                })
                .catch(function(error) {
                  ScrObj.output = error;

                  ScrObj.show(
                    "er-opd-pgn-foo-css",
                    "error",
                    "Save Data Error",
                    "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                      "<br>ErrorMessage : " +
                      ScrObj.output +
                      "<br>Date : " +
                      ScrObj.thaiDatetimeFc.ThaiDateTime(
                        ScrObj.thaiDatetimeFc.DateTimeNow()
                      )
                  );

                  console.log("OpdErProgressNoteAdd : " + ScrObj.output);
                });
            }
          }
        });
    },
    OpdErProgressNoteReplace(txt) {
      String.prototype.replaceAll = function(search, replacement) {
        var target = this;
        return target.split(search).join(replacement);
      };
      let PgNote = txt;
      PgNote = PgNote.replaceAll("<br />", "\n");
      PgNote = PgNote.replaceAll("<br>", "\n");
      PgNote = PgNote.replaceAll("<br >", "\n");
      return PgNote;
    },
    setOpdErProgressNote(vn, hn) {
      this.OpdErProgressNoteCh = "OpdErProgressNote" + vn;

      let CkScrObj = PatientOpdErProgressNote.query()
        .where("hn", hn)
        .where("vn", vn)
        .get();

      if (vn != "" && vn != null && CkScrObj.length >= 0) {
        let ScrObj = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "OpdErProgressNote", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn,
            vn: vn
          })
          .then(function(response) {
            ScrObj.output = response.data;
            if (ScrObj.output.status === true) {
              PatientOpdErProgressNote.delete({
                where(record) {
                  return record.vn == vn;
                }
              });

              let data = [];
              for (var val of ScrObj.output.result) {
                data.push({
                  id: val.vn + val.loginname,
                  loginname: val.loginname,
                  vn: val.vn,
                  hn: val.hn,
                  datas: val
                });
              }

              PatientOpdErProgressNote.insertOrUpdate({
                data
              });
            } else {
              if (ScrObj.output.ErrorMessage === "Data Not Found") {
                PatientOpdErProgressNote.delete({
                  where(record) {
                    return record.vn == vn;
                  }
                });
              }
            }
          })
          .catch(function(error) {
            ScrObj.output = error;
            console.log("OpdErProgressNote : " + ScrObj.output);
          })
          .finally(function() {
            ScrObj.OpdErProgressNoteCh = "OpdErProgressNote" + vn;
            ScrObj.getOpdErProgressNote(vn, hn);
            ScrObj.getUserOEPNote(vn, hn);
          });
      }
    },
    setOpdFastTrackStemi(vn, hn) {
      this.OpdFastTrackStemiCh = "OpdFastTrackStemi" + vn;

      let CkScrObj = PatientOpdFastTrackStemi.query()
        .where("hn", hn)
        .where("vn", vn)
        .get();

      if (vn != "" && vn != null && CkScrObj.length >= 0) {
        let ScrObj = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "OpdFastTrackStemi", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn,
            vn: vn
          })
          .then(function(response) {
            ScrObj.output = response.data;
            if (ScrObj.output.status === true) {
              PatientOpdFastTrackStemi.delete({
                where(record) {
                  return record.vn == vn;
                }
              });

              let data = [];
              for (var val of ScrObj.output.result) {
                data.push({ id: val.vn, vn: val.vn, hn: val.hn, datas: val });
              }

              PatientOpdFastTrackStemi.insertOrUpdate({
                data
              });
            } else {
              if (ScrObj.output.ErrorMessage === "Data Not Found") {
                PatientOpdFastTrackStemi.delete({
                  where(record) {
                    return record.vn == vn;
                  }
                });
              }
            }
          })
          .catch(function(error) {
            ScrObj.output = error;
            console.log("OpdFastTrackStemi : " + ScrObj.output);
          })
          .finally(function() {
            ScrObj.OpdErProgressNoteCh = "OpdFastTrackStemi" + vn;
            ScrObj.getOpdFastTrackStemi(vn, hn);
          });
      }
    },
    getOpdErProgressNote(vn, hn) {
      let ScrObj = PatientOpdErProgressNote.query()
        .where(record => record.datas.hn == hn)
        .where(record => record.datas.vn == vn)
        .get();

      if (ScrObj.length > 0) {
        this.OpdErProgressNoteData = ScrObj;
        this.apiCk = this.apiCk + 1;
      } else {
        this.OpdErProgressNoteData = null;
        this.apiCk = this.apiCk + 1;
      }
    },
    getOpdFastTrackStemi(vn, hn) {
      let ScrObj = PatientOpdFastTrackStemi.query()
        .where(record => record.datas.hn == hn)
        .where(record => record.datas.vn == vn)
        .get();

      if (ScrObj.length > 0) {
        this.OpdFastTrackStemiData = ScrObj[0];
        this.OpdFastTrackStemiTextData = ScrObj[0].datas.fast_track_stemi_text;

        if (this.OpdFastTrackStemiData.datas.indicators_data1_status == "Y") {
          this.indicators_date1 = this.thaiDatetimeFc.StrToDate(
            this.OpdFastTrackStemiData.datas.indicators_date1 +
              " " +
              this.OpdFastTrackStemiData.datas.indicators_time1
          );
          this.indicators_data1_status = true;
          this.indicators_time1 = this.thaiDatetimeFc.StrToDate(
            this.OpdFastTrackStemiData.datas.indicators_date1 +
              " " +
              this.OpdFastTrackStemiData.datas.indicators_time1
          );
        } else {
          this.indicators_data1_status = false;
          this.indicators_date1 = new Date();
          this.indicators_time1 = new Date();
        }

        if (this.OpdFastTrackStemiData.datas.indicators_data2_status == "Y") {
          this.indicators_date2 = this.thaiDatetimeFc.StrToDate(
            this.OpdFastTrackStemiData.datas.indicators_date2 +
              " " +
              this.OpdFastTrackStemiData.datas.indicators_time2
          );
          this.indicators_data2_status = true;
          this.indicators_time2 = this.thaiDatetimeFc.StrToDate(
            this.OpdFastTrackStemiData.datas.indicators_date2 +
              " " +
              this.OpdFastTrackStemiData.datas.indicators_time2
          );
        } else {
          this.indicators_data2_status = false;
          this.indicators_date2 = new Date();
          this.indicators_time2 = new Date();
        }

        if (this.OpdFastTrackStemiData.datas.indicators_data3_status == "Y") {
          this.indicators_date3 = this.thaiDatetimeFc.StrToDate(
            this.OpdFastTrackStemiData.datas.indicators_date3 +
              " " +
              this.OpdFastTrackStemiData.datas.indicators_time3
          );
          this.indicators_data3_status = true;
          this.indicators_time3 = this.thaiDatetimeFc.StrToDate(
            this.OpdFastTrackStemiData.datas.indicators_date3 +
              " " +
              this.OpdFastTrackStemiData.datas.indicators_time3
          );
        } else {
          this.indicators_data3_status = false;
          this.indicators_date3 = this.thaiDatetimeFc.DateNow();
          this.indicators_date3 = new Date();
          this.indicators_time3 = new Date();
        }

        if (this.OpdFastTrackStemiData.datas.indicators_data4_status == "Y") {
          this.indicators_date4 = this.thaiDatetimeFc.StrToDate(
            this.OpdFastTrackStemiData.datas.indicators_date4 +
              " " +
              this.OpdFastTrackStemiData.datas.indicators_time4
          );
          this.indicators_data4_status = true;
          this.indicators_time4 = this.thaiDatetimeFc.StrToDate(
            this.OpdFastTrackStemiData.datas.indicators_date4 +
              " " +
              this.OpdFastTrackStemiData.datas.indicators_time4
          );
        } else {
          this.indicators_data4_status = false;
          this.indicators_date4 = this.thaiDatetimeFc.DateNow();
          this.indicators_date4 = new Date();
          this.indicators_time4 = new Date();
        }

        if (this.OpdFastTrackStemiData.datas.indicators_data5_status == "Y") {
          this.indicators_date5 = this.thaiDatetimeFc.StrToDate(
            this.OpdFastTrackStemiData.datas.indicators_date5 +
              " " +
              this.OpdFastTrackStemiData.datas.indicators_time5
          );
          this.indicators_data5_status = true;
          this.indicators_time5 = this.thaiDatetimeFc.StrToDate(
            this.OpdFastTrackStemiData.datas.indicators_date5 +
              " " +
              this.OpdFastTrackStemiData.datas.indicators_time5
          );
        } else {
          this.indicators_data5_status = false;
          this.indicators_date5 = this.thaiDatetimeFc.DateNow();
          this.indicators_date5 = new Date();
          this.indicators_time5 = new Date();
        }

        this.apiCk = this.apiCk + 1;
      } else {
        this.OpdFastTrackStemiData = null;
        this.OpdFastTrackStemiTextData = " ";

        this.indicators_data1_status = false;
        this.indicators_data2_status = false;
        this.indicators_data3_status = false;
        this.indicators_data4_status = false;
        this.indicators_data5_status = false;

        this.indicators_date1 = new Date();
        this.indicators_date2 = new Date();
        this.indicators_date3 = new Date();
        this.indicators_date4 = new Date();
        this.indicators_time5 = new Date();

        this.indicators_time1 = new Date();
        this.indicators_time2 = new Date();
        this.indicators_time3 = new Date();
        this.indicators_time4 = new Date();
        this.indicators_time5 = new Date();

        this.apiCk = this.apiCk + 1;
      }
    },
    getUserOEPNote(vn, hn) {
      if (this.$store.get("systems@LoginData")) {
        let ScrObj = PatientOpdErProgressNote.query()
          .where(record => record.datas.hn == hn)
          .where(record => record.datas.vn == vn)
          .where(
            record =>
              record.datas.loginname ==
              this.$store.get("systems@LoginData").UserId
          )
          .get();

        if (ScrObj.length > 0) {
          this.UserOPDNoteFullData = ScrObj[0];
          this.UserOPDNoteData =
            ScrObj[0].datas.opd_progress_note_text +
            "<p>" +
            this.thaiDatetimeFc.ThaiDateTimeNonSec(
              this.thaiDatetimeFc.DateTimeNow()
            ) +
            " น. :&nbsp;</p>";

          if (this.UserOPDNoteDatavalue.length < this.UserOPDNoteData.length) {
            this.UserOPDNoteDatavalue = this.UserOPDNoteData;
          }

          this.apiCk = this.apiCk + 1;
        } else {
          this.UserOPDNoteFullData = null;
          this.UserOPDNoteData =
            "<p>" +
            this.thaiDatetimeFc.ThaiDateTimeNonSec(
              this.thaiDatetimeFc.DateTimeNow()
            ) +
            " น. :&nbsp;</p>";
          this.apiCk = this.apiCk + 1;

          this.UserOPDNoteDatavalue = this.UserOPDNoteData;
        }
      } else {
        this.UserOPDNoteFullData = null;
        this.UserOPDNoteData =
          "<p>" +
          this.thaiDatetimeFc.ThaiDateTimeNonSec(
            this.thaiDatetimeFc.DateTimeNow()
          ) +
          " น. :&nbsp;</p>";
        this.apiCk = this.apiCk + 1;

        this.UserOPDNoteDatavalue = " ";
      }
    },
    getEmrTemplate(TemplateType) {
      this.EmrTemplateSelected = null;

      let ScrObj = PatientEmrTemplate.query()
        .where(record => record.emr_template_type == TemplateType)
        .get();

      if (ScrObj.length > 0) {
        let data = [];
        data.push({
          value: null,
          text: "Please select Template"
        });
        for (var val of ScrObj) {
          data.push({
            value: val.id,
            text: val.datas.emr_template_name
          });
        }

        this.EmrTemplateData = data;
      } else {
        this.EmrTemplateData = null;
      }
    }
  }
})
export default class EmrOpdErProgressNote extends Vue {}
</script>

<style lang="scss">
.ck {
  p {
    margin: 0;
  }
}

.opd-er-progress-note-text {
  p {
    margin: 0;
  }
}

.ck-editor__editable {
  min-height: 200px;
}
</style>

